(function ($) {
  var elementorHookRegistered = false;

  function getTypeText($el) {
    var html = $el.html() || '';
    var textarea = document.createElement('textarea');

    html = html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/&lt;br\s*\/?&gt;/gi, '\n');

    textarea.innerHTML = html;

    return $.trim(textarea.value).replace(/<br\s*\/?>/gi, '\n');
  }

  function renderTypeText($el, text) {
    var parts = text.split(/\r\n|\r|\n/);

    $el.empty();

    $.each(parts, function (index, part) {
      if (index) {
        $el.append(document.createElement('br'));
      }

      $el.append(document.createTextNode(part));
    });
  }

  function stopTypeWriter($el) {
    var existingTimer = $el.data('heroTypewriterTimer');
    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    $el.removeData('heroTypewriterTimer');
  }

  function typeWriter($el, speed) {
    if (!$el.length) return;

    stopTypeWriter($el);

    var text = $el.attr('data-text');
    if (!text) {
      text = getTypeText($el);
      $el.attr('data-text', text);
    }

    $el.empty();
    var i = 0;

    function write() {
      renderTypeText($el, text.substring(0, i + 1));
      i++;
      if (i < text.length) {
        $el.data('heroTypewriterTimer', setTimeout(write, speed || 55));
      } else {
        $el.removeData('heroTypewriterTimer');
      }
    }

    write();
  }

  function resetCurrentText($heroSlider) {
    var $current = $heroSlider.find('.slider-content .single-slide.is-active');

    $current.find('.typewriter-anim').each(function () {
      var $el = $(this);
      renderTypeText($el, $el.attr('data-text') || '');
    });

    return $current;
  }

  function getSwiperIndex(swiper) {
    if ('number' === typeof swiper.realIndex) {
      return swiper.realIndex;
    }

    return swiper.activeIndex || 0;
  }

  function setActiveContent($heroSlider, activeIndex) {
    $heroSlider.find('.slider-content .single-slide').each(function (index) {
      var $slide = $(this);
      var isActive = index === activeIndex;

      $slide.toggleClass('is-active', isActive);

      if (!isActive) {
        $slide.find('.typewriter-anim').each(function () {
          var $el = $(this);
          stopTypeWriter($el);
          renderTypeText($el, $el.attr('data-text') || '');
        });
      }
    });
  }

  function animateCurrentText($heroSlider) {
    var $current = resetCurrentText($heroSlider);
    typeWriter($current.find('.typewriter-anim').first(), 55);
  }

  function getSwiperClass() {
    if (window.Swiper) {
      return window.Swiper;
    }

    if ('function' === typeof Swiper) {
      window.Swiper = Swiper;
      return Swiper;
    }

    return null;
  }

  function createHeroSwiper(SwiperClass, element, options) {
    return new SwiperClass(element, $.extend(true, {
      slidesPerView: 1,
      speed: 500,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      rewind: true,
      watchSlidesProgress: true,
      preloadImages: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    }, options || {}));
  }

  function initHeroSlider($scope) {
    var $heroSlider = $scope.find('.hero-slider').first();

    if (!$heroSlider.length || $heroSlider.data('hero-slider-initialized')) {
      return;
    }

    var SwiperClass = getSwiperClass();
    if (!SwiperClass) {
      return;
    }

    var $heroSwiper = $heroSlider.find('.hero-slider-swiper');
    var $sliderContent = $heroSlider.find('.slider-content');

    if (!$heroSwiper.length || !$sliderContent.length) {
      return;
    }

    $heroSlider.data('hero-slider-initialized', true);

    $sliderContent.find('.js-type').each(function () {
      var $el = $(this);
      $el.attr('data-text', getTypeText($el));
    });

    var heroSwiper = createHeroSwiper(SwiperClass, $heroSwiper[0]);
    setActiveContent($heroSlider, getSwiperIndex(heroSwiper));

    setTimeout(function () {
      animateCurrentText($heroSlider);
    }, 100);

    heroSwiper.on('slideChangeTransitionStart', function () {
      setActiveContent($heroSlider, getSwiperIndex(heroSwiper));
    });

    heroSwiper.on('slideChangeTransitionEnd', function () {
      animateCurrentText($heroSlider);
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/hero-slider.default',
      initHeroSlider
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();

    $('.elementor-widget-hero-slider').each(function () {
      initHeroSlider($(this));
    });
  });
})(jQuery);
